import Ad from "../gpt/Ad";
import SlotRenderEndedEvent from "../gpt/SlotRenderEndedEvent";
import Environment from "../util/Environment";
import fireEREvt from "../util/eventRecorderClient";
import { AdSizes } from "../viewability/Viewability";
import TaglessAdHandler from "./TaglessAdHandler";
import { FallbackAdConfig, FallbackAdStyle, ORIENTATION } from "./type";

// fallback ads constant
const dimensionMap: { [key: string]: ORIENTATION } = {
    "3,3": ORIENTATION.SQUARE,
    "5,16": ORIENTATION.HORIZONTAL
};

export const COMPASS_AD_URL: string = "https://compass.bloomberg.com/ads/play/blt7efc30dc0e168fff";

export const FALLBACK_ADS_POOL: {[key: string]: FallbackAdConfig} = {
    blt7efc30dc0e168fff: {
        url: "https://compass.bloomberg.com/ads/play/blt7efc30dc0e168fff",
        uid: "blt7efc30dc0e168fff"
    },
    blt371120ef439bdeb8: {
        url: "https://compass.bloomberg.com/ads/play/blt371120ef439bdeb8",
        uid: "blt371120ef439bdeb8"
    }
};

const styles: { [key: string]: FallbackAdStyle } = {
    horizontal: {
        containerSize: "100%",
        iframeStyle:
      "border:0px; height: 100vh; width: 100%; border: 0px; position: absolute; top: 0px; max-height:400px; min-height: 305px; max-width: 2000px;"
    },
    square: {
        containerSize: window.innerWidth > 769 ? "300px" : "100vw",
        iframeStyle:
      "border:0px; height: 100%; width: 100%; border: 0px; position: absolute; top: 0px; left: 0px;"
    }
};

/**
 * @class FallbackAd
 */
export default class FallbackAd extends TaglessAdHandler {

  orientation: ORIENTATION | null = ORIENTATION.HORIZONTAL;
  baseUrl: string = "";
  uid: string = "";

  constructor() {
      super(COMPASS_AD_URL);
      const fallbackAdKey = this._pickFallbackAds(Object.keys(FALLBACK_ADS_POOL));
      const { url, uid } = FALLBACK_ADS_POOL[fallbackAdKey];

      this.baseUrl = url;
      this.uid = uid;
  }

  private _pickFallbackAds(array: Array<string>):string {
      const randomPick = array[Math.floor(Math.random() * array.length)];

      return randomPick;
  }

  /**
   * get orientation from sizes for compass ads
   * @param {*} sizes
   * @returns
   */
  private _getOrientation(sizes: AdSizes): ORIENTATION | null {
      const sizeString: string = JSON.stringify(sizes);
      const found: string | undefined = Object.keys(dimensionMap).find(
          (dimension: string) => sizeString.includes(dimension)
      );

      if (!found) {
          return null;
      }

      this.orientation = dimensionMap[found];

      return this.orientation;
  }

  /**
   * override TaglessAdHandler decorateAd
   * @param {HTMLElement} iframe
   * @param {HTMLElement} container
   * @returns
   */
  decorateAd(iframe: HTMLElement, container: HTMLElement): void {
      if (!this.orientation) {
          return;
      }

      // container style
      const currentStyle: FallbackAdStyle = styles[this.orientation];

      if (!currentStyle || !iframe || !container) {
          return;
      }

      container.style.width = currentStyle.containerSize;
      container.style.height = currentStyle.containerSize;
      container.style.position = "relative";

      // iframe style
      iframe.setAttribute("style", currentStyle.iframeStyle);
      iframe.setAttribute("scrolling", "no");
      iframe.setAttribute("title", "fallback");
  }

  /**
   * override TaglessAdHandler createAdSrc
   * @param {*} ad
   * @returns
   */
  getAdSrc(ad: Ad): string | null {
      const sizes = ad.getSizes() || [];

      this.orientation = this._getOrientation(sizes);

      if (!this.orientation) {
          return null;
      }

      const urlParams: Record<string, string> = {
          orientation: this.orientation.toString(),
          creativeID: this.uid,
          lineID: "fallback",
          orderID: "fallback",
          adUnit: "fallback"
      };
      const searchParams: URLSearchParams = new URLSearchParams(urlParams);
      const url: string = `${ this.baseUrl }?${ searchParams.toString() }`;

      return url;
  }

  render(ad: Ad) {
      const adRenderEvent = ad.getSlotRenderedEvent();

      if (!adRenderEvent) {

          const newEvent = new SlotRenderEndedEvent({
              id: ad.getId(),
              adCode: ad.getUnitName(),
              requestTime: Environment.currentTime(),
              event: {
                  advertiserId: ad.getId(),
                  campaignId: "fallback",
                  lineItemId: "fallback",
                  creativeId: this.uid,
                  isEmpty: false,
                  size: []
              }
          });

          ad.setSlotRenderedEvent(newEvent);
      }
      super.render(ad);
      fireEREvt("ad-fallback-render", { containerId: ad.getContainerId() });
  }

}
